var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 56,
    viewBox: "0 0 101 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.214 49.4114V46.8161L11.786 46.8161V49.4114L89.214 49.4114Z",
    fill: "#DFDDDA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1907 46.8161H11.786V44.2207H9.1907V46.8161Z",
    fill: "#DFDDDA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59535 44.2207H9.1907V41.6254H6.59535V44.2207Z",
    fill: "#DFDDDA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.214 46.8161L91.8093 46.8161V44.2207H89.214V46.8161Z",
    fill: "#DFDDDA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8093 44.2207H94.4046V41.6254H91.8093V44.2207Z",
    fill: "#DFDDDA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.214 52.0068V49.4114L11.786 49.4114V52.0068L89.214 52.0068Z",
    fill: "#6A6967"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1907 49.4114L11.786 49.4114V46.8161H9.1907V49.4114Z",
    fill: "#6A6967"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59535 46.8161H9.1907V44.2207H6.59535V46.8161Z",
    fill: "#6A6967"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.214 49.4114H91.8093V46.8161L89.214 46.8161V49.4114Z",
    fill: "#6A6967"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8093 46.8161H94.4046V44.2207H91.8093V46.8161Z",
    fill: "#6A6967"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.214 54.6021V52.0068L11.786 52.0068L11.786 54.6021L89.214 54.6021Z",
    fill: "#363532"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97 16.537H94.4046V46.8161H97L97 16.537Z",
    fill: "#363532"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.537H6.59535L6.59535 46.8161H4L4 16.537Z",
    fill: "#363532"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8093 16.537H94.4046V13.9416H91.8093V16.537Z",
    fill: "#363532"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8093 49.4114H94.4046V46.8161H91.8093V49.4114Z",
    fill: "#363532"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1907 49.4114H6.59535L6.59535 46.8161H9.1907V49.4114Z",
    fill: "#363532"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.214 52.0068H91.8093V49.4114H89.214V52.0068Z",
    fill: "#363532"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.786 52.0068L9.1907 52.0068L9.1907 49.4114L11.786 49.4114V52.0068Z",
    fill: "#363532"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59535 16.537H9.1907V13.9416H6.59535L6.59535 16.537Z",
    fill: "#363532"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.786 42.0579H14.3814V39.4626H11.786V42.0579Z",
    fill: "#363532"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6186 1.39746V3.99281H14.3814V1.39746H86.6186Z",
    fill: "#363532"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.786 6.58816V3.99281H14.3814V6.58816H11.786Z",
    fill: "#363532"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.786 6.58816V39.4626H9.1907V6.58816H11.786Z",
    fill: "#363532"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.214 6.58816V3.99281H86.6186V6.58816H89.214Z",
    fill: "#363532"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M89.214 39.4626H91.8093V6.58816H89.214V39.4626Z",
    fill: "#363532"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6186 42.0579V39.4626H89.214V42.0579H86.6186Z",
    fill: "#363532"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6186 42.0579H14.3814V44.6533H86.6186V42.0579Z",
    fill: "#363532"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59535 16.537H9.1907L9.1907 41.6254H6.59535L6.59535 16.537Z",
    fill: "#AAA9A6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4046 16.537H91.8093V41.6254H94.4046V16.537Z",
    fill: "#AAA9A6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1907 39.4626H11.786V42.0579H9.1907V39.4626Z",
    fill: "#AAA9A6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8093 39.4626H89.214V42.0579H91.8093V39.4626Z",
    fill: "#AAA9A6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11.786 44.6533H89.214V46.8161L11.786 46.8161V44.6533Z",
    fill: "#AAA9A6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1907 42.0579H14.3814V44.6533H9.1907V42.0579Z",
    fill: "#AAA9A6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8093 42.0579H86.6186V44.6533H91.8093V42.0579Z",
    fill: "#AAA9A6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6186 34.2719V31.6765L14.3814 31.6765V34.2719L86.6186 34.2719Z",
    fill: "#FFEBA3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.786 31.6765H14.3814V29.0812H11.786V31.6765Z",
    fill: "#FFEBA3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6186 31.6765L89.214 31.6765V29.0812H86.6186V31.6765Z",
    fill: "#FFEBA3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6186 3.99281V6.58816H14.3814V3.99281H86.6186Z",
    fill: "#FFEBA3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.786 6.58816H14.3814V9.18351H11.786V6.58816Z",
    fill: "#FFEBA3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6186 6.58816H89.214V9.18351H86.6186V6.58816Z",
    fill: "#FFEBA3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11.786 9.18351H14.3814V11.7789H11.786V9.18351Z",
    fill: "#FFA000"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11.786 29.0812H14.3814V26.4858H11.786V29.0812Z",
    fill: "#FFA000"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M89.214 9.18351H86.6186V11.7789H89.214V9.18351Z",
    fill: "#FFA000"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M89.214 29.0812H86.6186V26.4858H89.214V29.0812Z",
    fill: "#FFA000"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3814 6.58816H16.9767V9.18351L14.3814 9.18351V6.58816Z",
    fill: "#FFA000"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3814 31.6765H16.9767V29.0812H14.3814V31.6765Z",
    fill: "#FFA000"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6186 6.58816H84.0233V9.18351L86.6186 9.18351V6.58816Z",
    fill: "#FFA000"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6186 31.6765L84.0233 31.6765V29.0812H86.6186V31.6765Z",
    fill: "#FFA000"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3814 11.7789H11.786V26.4858H14.3814V29.0812H16.9767V31.6765H84.0233V29.0812H86.6186V26.4858H89.214V11.7789H86.6186V9.18351L84.0233 9.18351V6.58816H16.9767V9.18351L14.3814 9.18351V11.7789Z",
    fill: "#FFC700"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3814 31.6765H11.786V39.4626H14.3814V42.0579H86.6186V39.4626H89.214V31.6765L86.6186 31.6765V34.2719L14.3814 34.2719V31.6765Z",
    fill: "#FFA000"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5115 19.289H60.6055V18.6077H59.8939V17.987H59.1824V15.2922H59.8939V14.6866H60.6055V14.0507H61.8318V12.8396H63.27V14.0507H64.5115V14.6866H65.2382V15.2922H65.9346V17.987H65.2382V18.6077H64.5115V19.289ZM60.6055 17.987H61.317V18.6077H63.7848V17.987H64.5115V15.3073H63.7848V14.6866H61.317V15.3073H60.6055V17.987ZM61.6501 21.6962V21.0149H63.0884V21.6962H63.8605V24.2397H69.0533V23.6189H70.4159V24.2397H69.7498V24.9209H63.1035V24.2397H62.3465V21.6962H61.6501ZM67.8876 13.5209V12.8396H69.2956V13.5209H70.0071V20.6819H69.2956V21.348H68.5689V13.5209H67.8876Z",
    fill: "#363532"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7236 12.7314H63.3782V13.9426H64.6196V14.5785H65.3463V15.184H66.0427V18.0952H65.3463V18.7159H64.6196V19.3972H60.4973V18.7159H59.7858V18.0952H59.0742V15.184H59.7858V14.5785H60.4973V13.9426H61.7236V12.7314ZM61.9399 12.9477V14.1589H60.7136V14.7947H60.0021V15.4003H59.2905V17.8789H60.0021V18.4996H60.7136V19.1809H64.4033V18.4996H65.13V17.8789H65.8265V15.4003H65.13V14.7947H64.4033V14.1589H63.1619V12.9477H61.9399ZM67.7795 12.7314H69.4037V13.4127H70.1153V20.79H69.4037V21.4561H68.4607V13.629H67.7795V12.7314ZM67.9957 12.9477V13.4127H68.677V21.2399H69.1874V20.5737H69.899V13.629H69.1874V12.9477H67.9957ZM61.2089 14.5785H63.8929V15.1992H64.6196V18.0952H63.8929V18.7159H61.2089V18.0952H60.4973V15.1992H61.2089V14.5785ZM61.4252 14.7947V15.4155H60.7136V17.8789H61.4252V18.4996H63.6766V17.8789H64.4033V15.4155H63.6766V14.7947H61.4252ZM61.542 20.9068H63.1965V21.5881H63.9686V24.1315H68.9452V23.5108H70.524V24.3478H69.8579V25.0291H62.9954V24.3478H62.2384V21.8044H61.542V20.9068ZM61.7582 21.1231V21.5881H62.4547V24.1315H63.2116V24.8128H69.6416V24.1315H70.3078V23.7271H69.1615V24.3478H63.7523V21.8044H62.9802V21.1231H61.7582Z",
    fill: "#363532"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3077 14.3075V13.6716H53.9683V14.2772H54.7252V18.6222H53.9683V19.9545H53.1961V20.6509H51.773V19.9545H52.4846V18.6222H53.1961V14.3075H46.3077ZM44.7331 22.9219V22.2557H56.6631V22.9219H44.7331Z",
    fill: "#363532"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1995 13.5635H54.0764V14.1691H54.8334V18.7304H54.0764V20.0627H53.3043V20.7591H51.6649V19.8464H52.3764V18.5141H53.088V14.4156H46.1995V13.5635ZM46.4158 13.7798V14.1993H53.3043V18.7304H52.5927V20.0627H51.8812V20.5428H53.088V19.8464H53.8601V18.5141H54.6171V14.3853H53.8601V13.7798H46.4158ZM44.625 22.1476H56.7712V23.03H44.625V22.1476ZM44.8413 22.3639V22.8137H56.555V22.3639H44.8413Z",
    fill: "#363532"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7052 19.9253V19.2743H31.9785V16.8065H32.7204V16.1707H38.8519V13.9452H32.3116V13.3093H39.624V13.93H40.3658V16.1707H39.624V16.8065H33.4773V19.2743H39.836V18.6384H41.1682V19.3197H40.5172V19.9253H32.7052ZM30.4949 23.5285V22.8624H35.7634V21.2878H35.067V20.6066H36.5658V21.2878H37.2925V22.8624H42.4248V23.5285H30.4949Z",
    fill: "#363532"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2035 13.2012H39.7321V13.8219H40.474V16.2788H39.7321V16.9147H33.5855V19.1661H39.7278V18.5303H41.2764V19.4278H40.6254V20.0334H32.5971V19.3824H31.8704V16.6984H32.6122V16.0625H38.7437V14.0533H32.2035V13.2012ZM32.4197 13.4175V13.837H38.96V16.2788H32.8285V16.9147H32.0867V19.1661H32.8134V19.8171H40.4091V19.2116H41.0601V18.7466H39.9441V19.3824H33.3692V16.6984H39.5159V16.0625H40.2577V14.0382H39.5159V13.4175H32.4197ZM34.9589 20.4984H36.674V21.1797H37.4006V22.7542H42.533V23.6366H30.3867V22.7542H35.6553V21.396H34.9589V20.4984ZM35.1751 20.7147V21.1797H35.8716V22.9705H30.603V23.4204H42.3167V22.9705H37.1844V21.396H36.4577V20.7147H35.1751Z",
    fill: "#363532"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.d874ad832aa00f871adbfff0afe18017.svg";
export { ForwardRef as ReactComponent };